import React from 'react';
import { InfoWindow } from '@react-google-maps/api';
import styled from 'styled-components';

// Styled Components
const InfoWindowContent = styled.div`
  padding: 12px;
  min-width: 280px;
  max-width: fit-content;
`;

const FriendName = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  letter-spacing: -0.3px;
`;

const InfoRow = styled.p`
  font-size: 12px;
  color: #000;
  word-wrap: break-word;
  margin-bottom: 6px;
  line-height: 1.5;

  strong {
    color: #000;
    font-weight: 600;
  }
`;

const LastUpdated = styled.p`
  font-size: 11px;
  color: #000;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #e0dddd;
  margin-bottom: 0;
`;

const FriendInfoWindow = ({
  friend = null,

  onClose = () => {},
  locationName = 'Loading location...',
  isLoadingLocation = false,
}) => {
  const { latitude, longitude } = friend.location;
  const { firstName, lastName } = friend.userInfo;
  const displayName = `${firstName} ${lastName}`;

  if (!friend || !friend.location || !friend.userInfo) {
    return null;
  }

  return (
    <InfoWindow
      position={{
        lat: parseFloat(latitude),
        lng: parseFloat(longitude),
      }}
      onCloseClick={onClose}
    >
      <InfoWindowContent>
        <FriendName>{displayName}</FriendName>

        <InfoRow>
          <strong>Location:</strong> {isLoadingLocation ? 'Loading...' : locationName}
        </InfoRow>

        <InfoRow>
          <strong>Coordinates:</strong>
          <br />
          {parseFloat(latitude).toFixed(6)}, {parseFloat(longitude).toFixed(6)}
        </InfoRow>

        <LastUpdated>
          <strong>Last Updated:</strong>
          <br />
          {new Date(friend.updatedAt).toLocaleString()}
        </LastUpdated>
      </InfoWindowContent>
    </InfoWindow>
  );
};

export default FriendInfoWindow;
